import Tool, { type ToolArgs } from '../../../../tools/Tool';
import { type CodeSnippetElement } from '../../../../types/aha-editor';
import { wrapInline } from '../../../InlinePlugin/utils';
import { isCodeSnippetActive, unwrapCodeSnippet } from '../utils';

// Toggles a code mark on the currently selected elements.
class ToolCodeSnippet extends Tool {
  static toolName = 'Code snippet';
  static iconClass = 'fa-regular fa-code';
  static mark = 'code';
  static shortcut = 'Cmd+/';

  static isActive({ editor }: ToolArgs): boolean {
    return isCodeSnippetActive(editor);
  }

  static action({ editor }: ToolArgs): void {
    if (!editor?.selection) return;

    if (isCodeSnippetActive(editor)) {
      unwrapCodeSnippet(editor);
      return;
    }

    const buildElement = (): CodeSnippetElement => {
      return {
        type: 'code-snippet',
        children: [{ text: '' }],
      };
    };

    wrapInline(editor, buildElement);
  }
}

export default ToolCodeSnippet;
